import { CloseTemplateBasis } from "../types/closeTemplateBasis";
import { TaskType } from "../types/task";

export enum OrganizationTaskTemplateIncompatibility {
    ARCHIVED = "archived",
    WORKSPACE = "workspace",
    BASIS = "basis",
}

interface CompatibilityTemplate {
    archivedAt: Date | null;
    workspaceId: string | null;
    type: TaskType | null;
}

interface FindOrganizationTaskTemplateIncompatibilityParams {
    template: CompatibilityTemplate;
    workspaceId: string | null;
    basis: CloseTemplateBasis | null;
}

/**
 * Why an org task template can't be used on a service template, or null when
 * it can. Org-wide templates (no workspace) are usable everywhere;
 * client-scoped ones only on a service template of the same workspace.
 * Accrual-review templates can't be used on modified-cash-ledger service
 * templates.
 */
export const findOrganizationTaskTemplateIncompatibility = ({
    template,
    workspaceId,
    basis,
}: FindOrganizationTaskTemplateIncompatibilityParams): OrganizationTaskTemplateIncompatibility | null => {
    if (template.archivedAt !== null) {
        return OrganizationTaskTemplateIncompatibility.ARCHIVED;
    }
    if (template.workspaceId !== null && template.workspaceId !== workspaceId) {
        return OrganizationTaskTemplateIncompatibility.WORKSPACE;
    }
    if (
        basis === CloseTemplateBasis.MODIFIED_CASH_LEDGER &&
        template.type === TaskType.ACCRUAL_REVIEW
    ) {
        return OrganizationTaskTemplateIncompatibility.BASIS;
    }
    return null;
};
